// модуль для отображения плавающей подсказки с информацией об оптовой цене товара
import {setTooltipPosition} from './calculate-position.js';

app.modules.wholesalePrice = (function (self) {
  let _timerId;
  let _currentTooltip;
  let _tooltipContent;

  function _handleClick(event) {
    const target = event.target;
    const isTooltipIcon = target.closest('.js-wholesale-tooltip');
    const isTooltipDescription = target.classList.contains(
      'wholesale-price__content'
    );

    if (
      _currentTooltip &&
      isTooltipIcon &&
      !_isTargetEqualToCurrentTooltip(target)
    ) {
      event.preventDefault();
      _hidePreviousTooltip(target);
      _changeTooltipState(target);
      return;
    }

    if (
      _currentTooltip &&
      (_isTargetEqualToCurrentTooltip(target) || isTooltipDescription)
    ) {
      event.preventDefault();
      return;
    }

    if (_currentTooltip && (!isTooltipIcon || !isTooltipDescription)) {
      _hidePreviousTooltip();
      return;
    }

    if (!isTooltipIcon) {
      return;
    }

    event.preventDefault();
    _currentTooltip = target;
    _changeTooltipState(target);
  }

  function _isTargetEqualToCurrentTooltip(target) {
    return target === _currentTooltip;
  }

  function _hidePreviousTooltip(target = null) {
    clearTimeout(_timerId);
    _toggleTooltipVisible(
      _tooltipContent,
      _currentTooltip.closest('.js-wholesale-tooltip')
    );
    _setValuesToTooltip(target);
  }

  function _toggleTooltipVisible(tooltip, target) {
    tooltip.classList.toggle('wholesale-price_visible');
    target.classList.toggle('wholesale-price__tooltip_visible');
  }

  function _setValuesToTooltip(currentTooltip = null) {
    _currentTooltip = currentTooltip;
    _tooltipContent = null;
  }

  function _changeTooltipState(target) {
    const wholesaleTooltip = target.closest('.js-wholesale-tooltip');

    const priceContainer = document.querySelector(
      `.js-price-container-${wholesaleTooltip.dataset.cardId}`
    );
    _tooltipContent = priceContainer.querySelector('.js-wholesale-price');

    _timerId = setTimeout(() => {
      _toggleTooltipVisible(_tooltipContent, wholesaleTooltip);
      _setValuesToTooltip();
    }, 4000);

    !wholesaleTooltip.classList.contains('js-tooltip-static-position') &&
      setTooltipPosition(_tooltipContent, priceContainer, wholesaleTooltip);
    _toggleTooltipVisible(_tooltipContent, wholesaleTooltip);
  }

  function _addListener() {
    document.addEventListener('touchend', _handleClick);
  }

  self.load = _addListener;
  return self;
})(app.modules.wholesalePrice || {});
